import React, { Component } from "react";
import BarLoader from "react-spinners/BarLoader";

const loader = <BarLoader height={4} width={"100vw"} color={"#00BFFF"} />;

class FamilyTree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: undefined,
            gedDataLocation: undefined,
        };
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ loading: true });

        /*

        Read gedcom file and replace all FILE lines that don't end in .ged with:

        window.location.href.replace("/familytree", "/familytreedata")/photos/name.jpg

        */

        // console.log("in componentDidMount");

        const originalGed = "/familytreedata/Fedorovsky_2026-08-18.ged";
        const location = window.location.href.replace("/familytree", "/familytreedata");

        fetch(originalGed)
            .then((response) => response.text())
            .then((textContent) => {
                // console.log("in fetch", textContent);
                const gedData = textContent.split("\n");
                let j = 0;
                gedData.forEach((line, i) => {
                    // console.log("in forEach", i, line);
                    const splitLine = line.split(" ");

                    // https://fedorovsky.ca/familytreedata/photos//Users/david/Pictures/Fedorovsky_2025-12-14.gpkg.media/photos/Hailey_Fedorovsky.jpg

                    if (splitLine[1] === "FILE" && !splitLine[splitLine.length - 1].includes(".ged")) {
                        console.log("in condition", splitLine[splitLine.length - 1]);
                        // replace the file location with the local reactjs location
                        splitLine[splitLine.length - 1] = `${location}familytreedata/photos/${splitLine[splitLine.length - 1].split("/").pop()}`;
                        // replace the line in the list
                        gedData[i] = splitLine.join(" ");
                        console.log("replaced line", gedData[i]);
                    }
                    j += 1;
                    // console.log("counters : ", i, j, gedData.length);
                    if (j === gedData.length - 1) {
                        // console.log("hit criteria, setting loader to false");
                        const newFile = new File([gedData.join("\n")], { type: "text/plain" });
                        const newGedDataLocation = URL.createObjectURL(newFile);
                        this.setState({ loading: false, gedDataLocation: newGedDataLocation }, () => {
                            // Wait for iframe to fully load
                            setTimeout(() => this.setupIframeStyles(), 200);
                        });
                    }
                });
            });
    }

    setupIframeStyles = () => {
        console.log("🔍 setupIframeStyles called");
        const iframe = document.querySelector("iframe");

        if (!iframe) {
            console.warn("⚠️  No iframe found, retrying in 100ms...");
            setTimeout(() => this.setupIframeStyles(), 100);
            return;
        }

        console.log("✓ Iframe element found");

        const attemptInject = (attempt = 1) => {
            try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                if (!iframeDoc) {
                    console.warn(`⚠️  Attempt ${attempt}: Cannot access iframe document, retrying...`);
                    if (attempt < 50) {
                        setTimeout(() => attemptInject(attempt + 1), 100);
                    }
                    return;
                }

                console.log(`✓ Iframe document accessible (attempt ${attempt})`);
                console.log(`  - readyState: ${iframeDoc.readyState}`);
                console.log(`  - body exists: ${!!iframeDoc.body}`);
                console.log(`  - head exists: ${!!iframeDoc.head}`);

                // Inject immediately and also wait for full load
                this.injectIframeStyles();

                // Add load listener for re-injection
                iframe.addEventListener("load", () => {
                    console.log("✓ Iframe load event fired, re-injecting styles");
                    setTimeout(() => this.injectIframeStyles(), 100);
                });
            } catch (e) {
                console.warn(`⚠️  Attempt ${attempt}: ${e.message}`);
                if (attempt < 50) {
                    setTimeout(() => attemptInject(attempt + 1), 100);
                }
            }
        };

        attemptInject();
    };

    componentDidUpdate(prevProps) {
        if (prevProps.nightMode !== this.props.nightMode) {
            setTimeout(() => this.injectIframeStyles(), 50);
        }
    }

    injectIframeStyles = () => {
        const iframe = document.querySelector("iframe");
        if (!iframe) return;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!iframeDoc) return;
        if (!this.props.nightMode) return;

        const oldStyle = iframeDoc.getElementById("nightModeStyles");
        if (oldStyle) oldStyle.remove();

        // Very aggressive CSS with maximum specificity and filters
        const style = iframeDoc.createElement("style");
        style.id = "nightModeStyles";
        style.textContent = `
            html { background: #1e1e1e !important; }
            body { background: #1e1e1e !important; color: #e0e0e0 !important; }
            * { background-color: #1e1e1e !important; color: #e0e0e0 !important; }
            svg { background-color: transparent !important; filter: invert(1) hue-rotate(180deg) !important; }
            canvas { background-color: transparent !important; }
            .ui.inverted { background-color: #2d2d2d !important; color: #e0e0e0 !important; }
            .ui:not(.inverted) { background-color: #2d2d2d !important; color: #e0e0e0 !important; }
            button { background-color: #0066cc !important; color: #fff !important; }
            input, textarea, select { background-color: #2d2d2d !important; color: #e0e0e0 !important; border-color: #555 !important; }
            a { color: #54b3ff !important; }
        `;
        iframeDoc.head.appendChild(style);

        // Direct DOM manipulation
        if (iframeDoc.body) {
            iframeDoc.body.style.backgroundColor = "#1e1e1e";
            iframeDoc.body.style.color = "#e0e0e0";
            iframeDoc.body.style.filter = "none";
        }

        if (iframeDoc.documentElement) {
            iframeDoc.documentElement.style.backgroundColor = "#1e1e1e";
            iframeDoc.documentElement.style.color = "#e0e0e0";
        }

        // Change SVG elements directly - invert their appearance
        setTimeout(() => {
            const svgs = iframeDoc.querySelectorAll("svg");
            for (let i = 0; i < svgs.length; i += 1) {
                const svgStyle = svgs[i].style;
                svgStyle.filter = "invert(1) hue-rotate(180deg)";
                svgStyle.backgroundColor = "transparent";
            }

            // Change text color in SVG
            const texts = iframeDoc.querySelectorAll("svg text, text");
            for (let i = 0; i < texts.length; i += 1) {
                const textStyle = texts[i].style;
                textStyle.fill = "#e0e0e0";
                textStyle.color = "#e0e0e0";
            }

            // Find all rect and path elements and adjust them
            const rects = iframeDoc.querySelectorAll("svg rect");
            for (let i = 0; i < rects.length; i += 1) {
                const rect = rects[i];
                const fill = rect.getAttribute("fill");
                // Only change light-colored elements
                if (fill && (fill.includes("#fff") || fill.includes("rgb(255") || fill === "white" || fill === "#f")) {
                    rect.setAttribute("fill", "#2d2d2d");
                    rect.setAttribute("stroke", "#666");
                }
            }
        }, 100);
    };

    render() {
        if (this.state.loading) return loader;

        // ged file is set in state as gedDataLocation after componentDidMount runs
        const drawIoEmbed = `<iframe frameborder="0" style="width:100%;height:85vh;" src="familyviewer/index.html#/view?url=${this.state.gedDataLocation}&handleCors=false&embedded=true"></iframe>`;

        return (
            <div className="App">
                <div dangerouslySetInnerHTML={{ __html: drawIoEmbed }}></div>
            </div>
        );
    }
}

export default FamilyTree;
